<template>
  <div
    class="profile__container--content__title primary-font"
    :class="
      $vuetify.breakpoint.smAndDown && edit
        ? 'profile__container--content__title--mobile'
        : ''
    "
  >
    <span v-if="!hideTitle" style="">{{ currentViewTitle }}</span>
    <div v-if="!hideEditButton">
      <v-btn
        class="mx-2"
        elevation="0"
        fab
        small
        :color="edit ? 'var(--v-primary-base)' : 'white'"
        :style="edit && !onlyToggle ? 'display: none' : ''"
        @click="$emit('toggleEdit')"
        v-if="!hideTitle && (isEditableChain || isEditablePortal)"
      >
        <v-icon :color="edit ? 'var(--v-primary-text-base)' : 'primary'"
          >fxt-pen
        </v-icon>
      </v-btn>
      <v-btn
        class="mr-2 text-none"
        rounded
        text
        :small="$vuetify.breakpoint.smAndDown"
        color="primary"
        v-if="
          !hideTitle && isEditablePortal && edit && !onlyToggle && isUserEdit
        "
        @click="$emit('changePassword')"
      >
        <div class="font-weight-bold">Endre passord</div>
        <v-icon class="pl-2">fxt-lock</v-icon>
      </v-btn>
      <v-btn
        class="text-none"
        elevation="0"
        rounded
        :small="$vuetify.breakpoint.smAndDown"
        outlined
        color="primary"
        v-if="
          !hideTitle &&
          (isEditableChain || isEditablePortal) &&
          edit &&
          !onlyToggle
        "
        @click="$emit('toggleEdit')"
      >
        Avbryt
      </v-btn>
      <v-btn
        class="ml-2 text-none"
        elevation="0"
        rounded
        :small="$vuetify.breakpoint.smAndDown"
        :disabled="!hasEdited"
        color="primary"
        v-if="
          !hideTitle &&
          (isEditableChain || isEditablePortal) &&
          edit &&
          !onlyToggle
        "
        @click="$emit('confirmAction')"
      >
        Lagre
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentViewTitle: {
      required: true,
      type: String,
    },
    edit: {
      required: false,
      default: false,
      type: Boolean,
    },
    layout: {
      required: false,
      default: "chain",
      type: String,
    },
    hideEditButton: {
      required: false,
      default: false,
      type: Boolean,
    },
    hasEdited: {
      required: false,
      default: false,
      type: Boolean,
    },
    onlyToggle: {
      required: false,
      default: true,
      type: Boolean,
    },
    isUserEdit: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  computed: {
    hideTitle() {
      return (
        [
          "Ordredetaljer",
          "Info fordelsprogram",
          "Bli med i fordelsprogram",
          "Poenghistorikk",
          "Vilkår for bruk",
        ].includes(this.currentViewTitle) ||
        (this.layout == "chain" && this.currentViewTitle == "Fordelsprogram") ||
        this.currentViewTitle == "Bli med i fordelsprogram"
      );
    },
    isEditableChain() {
      return [
        "Favorittansatte",
        "Favorittbehandlinger",
        "Favorittprodukter",
      ].includes(this.currentViewTitle);
    },
    isEditablePortal() {
      return (
        this.editableChain ||
        (["Profil", "Mine salonger"].includes(this.currentViewTitle) &&
          this.layout == "portal")
      );
    },
  },
};
</script>
